export enum Sections {
  accountSettingsTitle = "account.settings",
  accountSettingsIcon = "pi-cog",
  accountSettingsLink = "/accountSettings",

  profileInfoTitle = "account.profile",
  profileInfoIcon = "pi-id-card",
  profileInfoLink = "/userInfo",

}
